"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFromCustomFormat = exports.convertToCustomFormat = void 0;
var ConvertersComposer_1 = require("./ConvertersComposer");
var DateConverter_1 = require("./DateConverter");
var DefaultConverter_1 = require("./DefaultConverter");
var composedConverters = new ConvertersComposer_1.ConvertersComposer(new DateConverter_1.DateConverter(), new DefaultConverter_1.DefaultConverter());
var convertToCustomFormat = function (item) { return composedConverters.convertToCustomFormat(item); };
exports.convertToCustomFormat = convertToCustomFormat;
var convertFromCustomFormat = function (item) { return composedConverters.convertFromCustomFormat(item); };
exports.convertFromCustomFormat = convertFromCustomFormat;
//# sourceMappingURL=index.js.map